import createActionTypes from './utils';

export const MANAGE_TOKENS_LIST = createActionTypes('MANAGE_TOKENS_LIST');
export const MANAGE_TOKENS_MODALS_OPEN = 'MANAGE_TOKENS_MODALS_OPEN';
export const MANAGE_TOKENS_MODALS_CLOSE = 'MANAGE_TOKENS_MODALS_CLOSE';
